import axios from "axios";
import { PayPaymentRequestRequest, PayPaymentRequestResponse } from "./types";

const baseURL = import.meta.env.VITE_API_BASE_URL ?? "";

// Public pay endpoint — uses a raw axios call (no auth, no company UUID
// header) since the token in the URL is the credential.
export async function payPaymentRequest(
  token: string,
  data: PayPaymentRequestRequest,
): Promise<PayPaymentRequestResponse> {
  const response = await axios.post(
    `${baseURL}/api/public/payment-requests/${encodeURIComponent(token)}/pay`,
    data,
  );
  return response.data?.data ?? response.data;
}
